import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NglTabs } from './tabs';
import { NglTab } from './tab';
import { NglTabVerbose, NglTabContent, NglTabHeading } from './tab-verbose';
import { NglInternalOutletModule } from '../util/outlet.module';
var NGL_TAB_DIRECTIVES = [
    NglTabs,
    NglTab,
    NglTabVerbose, NglTabContent, NglTabHeading,
];
var NglTabsModule = (function () {
    function NglTabsModule() {
    }
    NglTabsModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [NGL_TAB_DIRECTIVES],
                    exports: [NGL_TAB_DIRECTIVES],
                    imports: [CommonModule, NglInternalOutletModule],
                },] },
    ];
    /** @nocollapse */
    NglTabsModule.ctorParameters = function () { return []; };
    return NglTabsModule;
}());
export { NglTabsModule };
//# sourceMappingURL=module.js.map